export default "__VITE_ASSET__JkZpr99s__"